import React, { useCallback } from 'react'
import { Box } from '@mui/material'
import { SignalSlashIcon } from '@heroicons/react/24/outline'
import { useTranslation } from '../../hooks/useIntractionTranslate'
import { INTERAX_COLORS } from '../../../constants/colors'
import { TESTIDS } from '../../../config/testids'
import { NotificationCard } from './NotificationCard'

interface SlowNetworkNotificationProps {
  onDismiss: () => void
}

/** Shown once per browser session when the link looks too slow to play or talk on. Stays until
 * dismissed — a warning that vanishes on its own is one the user never finished reading. */
export const SlowNetworkNotification: React.FC<SlowNetworkNotificationProps> = ({ onDismiss }) => {
  const { t } = useTranslation()

  const handleDismiss = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()
      onDismiss()
    },
    [onDismiss]
  )

  return (
    <Box data-testid={TESTIDS.SLOW_NETWORK_NOTIFICATION}>
      <NotificationCard
        icon={<SignalSlashIcon style={{ width: '18px', height: '18px', color: INTERAX_COLORS.sun }} aria-hidden />}
        title={t('common.slowNetwork.title', 'Your connection looks slow')}
        subtitle={t(
          'common.slowNetwork.subtitle',
          'Video, voice and the game may stutter. Closing other tabs and apps usually helps.'
        )}
        onCloseClick={handleDismiss}
        isVisible
        closeButtonAriaLabel={t('common.slowNetwork.dismiss', 'Dismiss')}
      />
    </Box>
  )
}
